import { Paging } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Paging';

export const useTablePagination = (paging: Paging, changePaging: (paging: Paging) => void) => {
  const numberOfItemsOnPage = paging.take;
  const totalItemNumber = paging.total;
  const currentPageNumber = paging.skip / numberOfItemsOnPage + 1;
  const totalPageNumber = Math.ceil(totalItemNumber / numberOfItemsOnPage);

  const onPageChange = (pageNumber: number) => {
    const newPaging: Paging = {
      ...paging,
      skip: (pageNumber - 1) * numberOfItemsOnPage
    };
    changePaging(newPaging);
  };

  const onItemsPerPageChange = (itemsPerPage: number) => {
    const newPaging: Paging = {
      ...paging,
      skip: 0,
      take: itemsPerPage
    };
    changePaging(newPaging);
  };

  return {
    currentPageNumber,
    totalPageNumber,
    numberOfItemsOnPage,
    totalItemNumber,
    onPageChange,
    onItemsPerPageChange
  };
};
